export enum ConstructionConditionOption {
  NO_INFORMATION = 'NO_INFORMATION',
  FIRST_TIME_USE = 'FIRST_TIME_USE',
  FIRST_TIME_USE_AFTER_REFURBISHMENT = 'FIRST_TIME_USE_AFTER_REFURBISHMENT',
  MINT_CONDITION = 'MINT_CONDITION',
  REFURBISHED = 'REFURBISHED',
  MODERNIZED = 'MODERNIZED',
  FULLY_RENOVATED = 'FULLY_RENOVATED',
  WELL_KEPT = 'WELL_KEPT',
  NEED_OF_RENOVATION = 'NEED_OF_RENOVATION',
  NEGOTIABLE = 'NEGOTIABLE',
  RIPE_FOR_DEMOLITION = 'RIPE_FOR_DEMOLITION',
}

export enum FlooringTypeOption {
  NO_INFORMATION = 'NO_INFORMATION',
  CONCRETE = 'CONCRETE',
  EPOXY_RESIN = 'EPOXY_RESIN',
  TILES = 'TILES',
  PLANKS = 'PLANKS',
  LAMINATE = 'LAMINATE',
  PARQUET = 'PARQUET',
  PVC = 'PVC',
  CARPET = 'CARPET',
  ANTISTATIC_FLOOR = 'ANTISTATIC_FLOOR',
  OFFICE_CARPET = 'OFFICE_CARPET',
  STONE = 'STONE',
  CUSTOMIZABLE = 'CUSTOMIZABLE',
  WITHOUT = 'WITHOUT',
}

export enum ParkingSpaceTypeOption {
  NONE = 'NONE',
  OUTSIDE = 'OUTSIDE',
  CARPORT = 'CARPORT',
  DUPLEX = 'DUPLEX',
  GARAGE = 'GARAGE',
  CAR_PARK = 'CAR_PARK',
  UNDERGROUND_GARAGE = 'UNDERGROUND_GARAGE',
}

export enum EnergySourceOption {
  NO_INFORMATION = 'NO_INFORMATION',
  GEOTHERMAL = 'GEOTHERMAL',
  SOLAR_HEATING = 'SOLAR_HEATING',
  PELLET_HEATING = 'PELLET_HEATING',
  GAS = 'GAS',
  OIL = 'OIL',
  DISTRICT_HEATING = 'DISTRICT_HEATING',
  ELECTRICITY = 'ELECTRICITY',
  COAL = 'COAL',
  NATURAL_GAS_LIGHT = 'NATURAL_GAS_LIGHT',
  NATURAL_GAS_HEAVY = 'NATURAL_GAS_HEAVY',
  LIQUID_GAS = 'LIQUID_GAS',
  STEAM_DISTRICT_HEATING = 'STEAM_DISTRICT_HEATING',
  WOOD = 'WOOD',
  WOOD_CHIPS = 'WOOD_CHIPS',
  COAL_COKE = 'COAL_COKE',
  LOCAL_HEATING = 'LOCAL_HEATING',
  HEAT_SUPPLY = 'HEAT_SUPPLY',
  BIO_ENERGY = 'BIO_ENERGY',
  WIND_ENERGY = 'WIND_ENERGY',
  HYDRO_ENERGY = 'HYDRO_ENERGY',
  ENVIRONMENTAL_THERMAL_ENERGY = 'ENVIRONMENTAL_THERMAL_ENERGY',
  COMBINED_HEAT_AND_POWER_FOSSIL_FUELS = 'COMBINED_HEAT_AND_POWER_FOSSIL_FUELS',
  COMBINED_HEAT_AND_POWER_RENEWABLE_ENERGY = 'COMBINED_HEAT_AND_POWER_RENEWABLE_ENERGY',
  COMBINED_HEAT_AND_POWER_REGENERATIVE_ENERGY = 'COMBINED_HEAT_AND_POWER_REGENERATIVE_ENERGY',
  COMBINED_HEAT_AND_POWER_BIO_ENERGY = 'COMBINED_HEAT_AND_POWER_BIO_ENERGY',
}

export enum HeatingTypeOption {
  NO_INFORMATION = 'NO_INFORMATION',
  COMBINED_HEAT_AND_POWER_PLANT = 'COMBINED_HEAT_AND_POWER_PLANT',
  ELECTRIC_HEATING = 'ELECTRIC_HEATING',
  SELF_CONTAINED_CENTRAL_HEATING = 'SELF_CONTAINED_CENTRAL_HEATING',
  DISTRICT_HEATING = 'DISTRICT_HEATING',
  FLOOR_HEATING = 'FLOOR_HEATING',
  GAS_HEATING = 'GAS_HEATING',
  WOOD_PELLET_HEATING = 'WOOD_PELLET_HEATING',
  NIGHT_STORAGE_HEATER = 'NIGHT_STORAGE_HEATER',
  STOVE_HEATING = 'STOVE_HEATING',
  OIL_HEATING = 'OIL_HEATING',
  SOLAR_HEATING = 'SOLAR_HEATING',
  HEAT_PUMP = 'HEAT_PUMP',
  CENTRAL_HEATING = 'CENTRAL_HEATING',
}

export enum EfficiencyClassOption {
  NO_INFORMATION = 'NO_INFORMATION',
  A_PLUS = 'A_PLUS',
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H',
}

export enum AreaCoverageOption {
  NO_INFORMATION = 'NO_INFORMATION',
  DEVELOPED = 'DEVELOPED',
  DEVELOPED_PARTIALLY = 'DEVELOPED_PARTIALLY',
  NOT_DEVELOPED = 'NOT_DEVELOPED',
}

export enum BuildingTypeOption {
  NO_INFORMATION = 'NO_INFORMATION',
  SHOWROOM_SPACE = 'SHOWROOM_SPACE',
  ATTIC = 'ATTIC',
  GROUND_FLOOR = 'GROUND_FLOOR',
  APARTMENT = 'APARTMENT',
  ENTRESOL = 'ENTRESOL',
  LOFT = 'LOFT',
  DUPLEX = 'DUPLEX',
  PENTHOUSE = 'PENTHOUSE',
  BASEMENT = 'BASEMENT',
  TERRACE = 'TERRACE',
  OTHER = 'OTHER',
  HALL = 'HALL',
  HIGH_LACK_STORAGE = 'HIGH_LACK_STORAGE',
  INDUSTRY_HALL = 'INDUSTRY_HALL',
  INDUSTRY_HALL_WITH_OPEN_AREA = 'INDUSTRY_HALL_WITH_OPEN_AREA',
  COLD_STORAGE = 'COLD_STORAGE',
  MULTIDECK_CABINET_STORAGE = 'MULTIDECK_CABINET_STORAGE',
  STORAGE_WITH_OPEN_AREA = 'STORAGE_WITH_OPEN_AREA',
  STORAGE_AREA = 'STORAGE_AREA',
  STORAGE_HALL = 'STORAGE_HALL',
  SERVICE_AREA = 'SERVICE_AREA',
  SHIPPING_STORAGE = 'SHIPPING_STORAGE',
  REPAIR_SHOP = 'REPAIR_SHOP',
  STUDIO = 'STUDIO',
  OFFICE = 'OFFICE',
  OFFICE_FLOOR = 'OFFICE_FLOOR',
  OFFICE_BUILDING = 'OFFICE_BUILDING',
  OFFICE_CENTRE = 'OFFICE_CENTRE',
  OFFICE_STORAGE_BUILDING = 'OFFICE_STORAGE_BUILDING',
  SURGERY = 'SURGERY',
  SURGERY_FLOOR = 'SURGERY_FLOOR',
  SURGERY_BUILDING = 'SURGERY_BUILDING',
  COMMERCIAL_CENTRE = 'COMMERCIAL_CENTRE',
  LIVING_AND_COMMERCIAL_BUILDING = 'LIVING_AND_COMMERCIAL_BUILDING',
  OFFICE_AND_COMMERCIAL_BUILDING = 'OFFICE_AND_COMMERCIAL_BUILDING',
  GARAGE = 'GARAGE',
  UNDERGROUND_GARAGE = 'UNDERGROUND_GARAGE',
  CAR_PARK = 'CAR_PARK',
  CARPORT = 'CARPORT',
  STREET_PARKING = 'STREET_PARKING',
  SINGLE_FAMILY_HOUSE = 'SINGLE_FAMILY_HOUSE',
  MID_TERRACE_HOUSE = 'MID_TERRACE_HOUSE',
  END_TERRACE_HOUSE = 'END_TERRACE_HOUSE',
  MULTI_FAMILY_HOUSE = 'MULTI_FAMILY_HOUSE',
  BUNGALOW = 'BUNGALOW',
  FARMHOUSE = 'FARMHOUSE',
  SEMIDETACHED_HOUSE = 'SEMIDETACHED_HOUSE',
  VILLA = 'VILLA',
  CASTLE_MANOR_HOUSE = 'CASTLE_MANOR_HOUSE',
  SPECIAL_REAL_ESTATE = 'SPECIAL_REAL_ESTATE',
  SHOPPING_CENTRE = 'SHOPPING_CENTRE',
  FACTORY_OUTLET = 'FACTORY_OUTLET',
  DEPARTMENT_STORE = 'DEPARTMENT_STORE',
  KIOSK = 'KIOSK',
  STORE = 'STORE',
  SELF_SERVICE_MARKET = 'SELF_SERVICE_MARKET',
  SALES_AREA = 'SALES_AREA',
  SALES_HALL = 'SALES_HALL',
  FLAT = 'FLAT',
  HOUSE = 'HOUSE',
  ROOM = 'ROOM',
  BAR_LOUNGE = 'BAR_LOUNGE',
  CAFE = 'CAFE',
  CLUB_DISCO = 'CLUB_DISCO',
  GUESTS_HOUSE = 'GUESTS_HOUSE',
  TAVERN = 'TAVERN',
  HOTEL = 'HOTEL',
  HOTEL_RESIDENCE = 'HOTEL_RESIDENCE',
  HOTEL_GARNI = 'HOTEL_GARNI',
  PENSION = 'PENSION',
  RESTAURANT = 'RESTAURANT',
  FREEHOLD_FLAT = 'FREEHOLD_FLAT',
  LEISURE_FACILITY = 'LEISURE_FACILITY',
  COMMERCIAL_UNIT = 'COMMERCIAL_UNIT',
  COMMERCIAL_BUILDING = 'COMMERCIAL_BUILDING',
  COMMERCIAL_PROPERTY = 'COMMERCIAL_PROPERTY',
  HALL_STORAGE = 'HALL_STORAGE',
  INDUSTRIAL_PROPERTY = 'INDUSTRIAL_PROPERTY',
  SHOP_SALES_FLOOR = 'SHOP_SALES_FLOOR',
  SERVICE_CENTRE = 'SERVICE_CENTRE',
  SUPERMARKET = 'SUPERMARKET',
  LIVING_BUSINESS_HOUSE = 'LIVING_BUSINESS_HOUSE',
  HOUSING_ESTATE = 'HOUSING_ESTATE',
}

export enum ConstructibleAfterOption {
  NO_INFORMATION = 'NO_INFORMATION',
  EXTERNALAREA = 'EXTERNALAREA',
  CONSTRUCTIONPLAN = 'CONSTRUCTIONPLAN',
  NEIGHBOURCONSTRUCTION = 'NEIGHBOURCONSTRUCTION',
}

export enum LocationClassificationTypeOption {
  NO_INFORMATION = 'NO_INFORMATION',
  CLASSIFICATION_A = 'CLASSIFICATION_A',
  CLASSIFICATION_B = 'CLASSIFICATION_B',
  SHOPPING_CENTRE = 'SHOPPING_CENTRE',
}

export enum SupplyTypeOption {
  NO_INFORMATION = 'NO_INFORMATION',
  DIRECT_APPROACH = 'DIRECT_APPROACH',
  NO_DIRECT_APPROACH = 'NO_DIRECT_APPROACH',
  CAR_APPROACH = 'CAR_APPROACH',
  APPROACH_TO_THE_FRONT = 'APPROACH_TO_THE_FRONT',
  APPROACH_TO_THE_BACK = 'APPROACH_TO_THE_BACK',
  FULL_TIME = 'FULL_TIME',
  FORENOON = 'FORENOON',
}

export enum UsageTypeOption {
  TRADE = 'TRADE',
  AGRICULTURE_FORESTRY = 'AGRICULTURE_FORESTRY',
  LEISURE = 'LEISURE',
}

export enum ConstructionPhaseOption {
  NO_INFORMATION = 'NO_INFORMATION',
  PROJECTED = 'PROJECTED',
  UNDER_CONSTRUCTION = 'UNDER_CONSTRUCTION',
  COMPLETED = 'COMPLETED',
}

export enum DefaultRentPriceTypeOption {
  RENT_PER_MONTH_PRICE = 'RENT_PER_MONTH_PRICE',
  RENT_PER_SQM_PRICE = 'RENT_PER_SQM_PRICE',
  REQUEST_RENT_PRICE = 'REQUEST_RENT_PRICE',
}

export enum CalendaredRentPriceTypeOption {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}
